import { AddViewSupport47Container } from "../../../containers/SupportSystem/ViewReports/AddViewSupport47Container"
export function AddViewSupport47Page() {
    return (
        <AddViewSupport47Container />
    )
}